export default "__VITE_ASSET__ad86fa2a__"